var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hover-container",class:[_vm.hoverDesign, _vm.hoverColor]},[_c('div',{staticClass:"bg1"}),_c('div',{staticClass:"bg2"}),_c('div',{staticClass:"bg3"}),_c('div',{staticClass:"bg4"}),_c('div',{staticClass:"bgItem1"})])
}
var staticRenderFns = []

export { render, staticRenderFns }